<template>
    <button
    type="button"
    class="btn btn-primary btn-block p-2 btn-notifications"
    v-on:click.prevent="install()"
	v-if='$root.deferredInstallPrompt'>{{ $t('translations.add_to_home_screen')}}</button>
</template>

<script>
import axios from "axios";

export default {
	data: function() {
		return {

		};
	},

  	mounted() {
        //console.log("isPushEnabled: " + this.$root.isPushEnabled)
	},

	computed: {
	},

	watch: {},

  	methods: {
        install() {
            // Attach the install prompt to a user gesture
            // Show the prompt
            this.$root.deferredInstallPrompt.prompt();

            // Wait for the user to respond to the prompt
            this.$root.deferredInstallPrompt.userChoice
                .then((choiceResult) => {
                    if (choiceResult.outcome === 'accepted') {
                        console.log('User accepted the A2HS prompt');
                    } else {
                        console.log('User dismissed the A2HS prompt');
                    }
                    this.$root.deferredInstallPrompt = null;
                });
            },
	}
};
</script>
